import React from 'react';
import moment from 'moment';
import { isNumber } from 'lodash';
import { DATE_SHORTCUTS } from '@utils/constants';
import { calcShortcutInterval } from '@utils';
import getGranularity from '@utils/granularity';
import { isPolicyMode } from '@src/pages/TrackingPolicy/utils/helper';

const withinAllowedMonths = (months, allowedMonths) => {
  if (isNumber(allowedMonths) && isNumber(months) && months > allowedMonths) return false;
  return true;
};

const getDateShortcuts = (liveMode, allowedMonths) => {
  let last15MShortcut: any = [];

  const policyTrackingMode = isPolicyMode();

  const hourly_shortcuts = [
    [DATE_SHORTCUTS.last2Hours, calcShortcutInterval(DATE_SHORTCUTS.last2Hours)],
    [DATE_SHORTCUTS.last6Hours, calcShortcutInterval(DATE_SHORTCUTS.last6Hours)],
    [DATE_SHORTCUTS.past24Hours, calcShortcutInterval(DATE_SHORTCUTS.past24Hours)],
  ];

  const base_shortcuts = [
    // [DATE_SHORTCUTS.last1Hour, calcShortcutInterval(DATE_SHORTCUTS.last1Hour)],
    // [DATE_SHORTCUTS.last2Hours, calcShortcutInterval(DATE_SHORTCUTS.last2Hours)],
    // [DATE_SHORTCUTS.last6Hours, calcShortcutInterval(DATE_SHORTCUTS.last6Hours)],
    // [DATE_SHORTCUTS.past24Hours, calcShortcutInterval(DATE_SHORTCUTS.past24Hours)],
    [DATE_SHORTCUTS.today, calcShortcutInterval(DATE_SHORTCUTS.today)],
    [DATE_SHORTCUTS.yesterday, calcShortcutInterval(DATE_SHORTCUTS.yesterday)],
    [DATE_SHORTCUTS.past7Days, calcShortcutInterval(DATE_SHORTCUTS.past7Days)],
    [DATE_SHORTCUTS.lastWeek, calcShortcutInterval(DATE_SHORTCUTS.lastWeek)],
    [DATE_SHORTCUTS.thisMonth, calcShortcutInterval(DATE_SHORTCUTS.thisMonth)],
    withinAllowedMonths(2, allowedMonths) && [
      DATE_SHORTCUTS.lastMonth,
      calcShortcutInterval(DATE_SHORTCUTS.lastMonth),
    ],
    [DATE_SHORTCUTS.past30Days, calcShortcutInterval(DATE_SHORTCUTS.past30Days)],
    withinAllowedMonths(3, allowedMonths) && [
      DATE_SHORTCUTS.past90Days,
      calcShortcutInterval(DATE_SHORTCUTS.past90Days),
    ],
    withinAllowedMonths(12, allowedMonths) && [
      DATE_SHORTCUTS.past1Year,
      calcShortcutInterval(DATE_SHORTCUTS.past1Year),
    ],
  ].filter(Boolean);

  const shortcuts = policyTrackingMode ? base_shortcuts : [...hourly_shortcuts, ...base_shortcuts];

  if (liveMode) {
    last15MShortcut = [
      [DATE_SHORTCUTS.last15Mins, calcShortcutInterval(DATE_SHORTCUTS.last15Mins)],
    ];
  }

  return [...last15MShortcut, ...shortcuts];
};

/**
 * withDefaultOptions
 * This provides default options -> DisabledDate and shortcut dates
 */
const withDefaultOptions = (Wrapper) => {
  class WithDefaultOptionsHOC extends React.PureComponent {
    getDisabledDate = () => (current) => {
      // To avoid error caused by invalid current
      if (!current) return true;

      const { durationAllowed }: any = this.props;

      // fix CE-11097, backend set the data retention 31 days one month.
      // momentJs takes into account the number of days of the natural month
      const subtractDays = durationAllowed * 30; // Treat each month as 31 days

      return (
        current.isAfter(moment(), 'day') ||
        current.isBefore(moment().subtract(subtractDays, 'days'), 'day')
      );
    };

    getTimeGranularity = (from, to) => {
      const g = getGranularity({ from, to, minuteGranularity: true });
      switch (g) {
        case 'PT1M':
          return 5;
        case 'PT1H':
          return 60;
        default:
          return null;
      }
    };

    render() {
      const { innerRef, liveMode, durationAllowed, ...rest }: any = this.props;
      const shortcuts = getDateShortcuts(liveMode, durationAllowed);

      return (
        <Wrapper
          disabledDate={this.getDisabledDate()}
          shortcuts={shortcuts}
          granularity={this.getTimeGranularity}
          ref={innerRef}
          {...rest}
        />
      );
    }
  }

  WithDefaultOptionsHOC.defaultProps = {
    innerRef: React.createRef(),
    durationAllowed: 13, // months
  };
  return WithDefaultOptionsHOC;
};

export default withDefaultOptions;
